import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "360",
  height: "360",
  fill: "none",
  viewBox: "0 0 360 360"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M252.072 212.292c-6.246 8.37-19.386 22.266-26.694 22.266h-33.966v-22.284h27.054c3.87 0 7.56-1.566 10.224-4.32 13.896-14.4 21.924-31.536 21.924-49.914 0-31.356-23.436-59.076-59.22-75.78V67.284c0-6.444-5.22-11.664-11.664-11.664s-11.664 5.22-11.664 11.664v6.21a190.85 190.85 0 0 0-31.734-6.444c18.36 19.944 29.574 46.62 29.574 75.87 0 26.226-8.964 50.31-24.03 69.39h26.19v22.32h-38.34a9.391 9.391 0 0 1-9.396-9.396v-9.756a3.115 3.115 0 0 0-3.114-3.114H66.672c-.99 0-1.836.81-1.836 1.8-.036 39.924 31.554 69.894 69.336 69.894h106.65c25.56 0 36.99-32.76 51.966-53.604 5.814-8.064 19.764-14.544 23.994-16.344.774-.324 1.224-1.044 1.224-1.89v-12.96c0-1.314-1.296-2.304-2.574-1.944 0 0-61.65 14.166-62.37 14.364-.72.216-.99.63-.99.63v-.018Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M146.16 142.83c0-20.106-6.894-38.61-18.414-53.244L69.732 189.972h62.406c8.874-13.536 14.04-29.736 14.04-47.124l-.018-.018Z"
    }, null, -1)
  ])))
}
export default { render: render }